import { render, staticRenderFns } from "./itemTalk.vue?vue&type=template&id=329240eb&scoped=true&"
import script from "./itemTalk.vue?vue&type=script&lang=js&"
export * from "./itemTalk.vue?vue&type=script&lang=js&"
import style0 from "./itemTalk.vue?vue&type=style&index=0&id=329240eb&prod&lange=scss&scoped=true&lang=css&"
import style1 from "./itemTalk.vue?vue&type=style&index=1&id=329240eb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "329240eb",
  null
  
)

export default component.exports